import React from "react";
import { useNavigate } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";

export interface TabItem {
  value: string;
  label: string;
}

interface DynamicTabsProps {
  activeTab?: string;
  activeType?: string;
  tabs: TabItem[];
  basePath: string;
  /** When set (e.g. tags-search), switch tabs without changing the route */
  onTabChange?: (value: string) => void;
}

export default function DynamicTabs({
  activeTab,
  activeType,
  tabs,
  basePath,
  onTabChange,
}: DynamicTabsProps) {
  const navigate = useNavigate();

  // Convert activeTab string → index for smooth animation
  const activeIndex = tabs.findIndex(
    (t) => t.value.toLowerCase() === activeTab?.toLowerCase()
  );

  const handleChange = (event: React.SyntheticEvent, newIndex: number) => {
    const newTab = tabs[newIndex];
    if (onTabChange) {
      onTabChange(newTab.value);
    } else {
      navigate(`/${basePath}/${activeType}/${newTab.value}`);
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={activeIndex >= 0 ? activeIndex : 0}
        onChange={handleChange}
        sx={{
          minHeight: 32,
          "& .MuiTab-root": {
            fontFamily: "'Poppins', sans-serif",
            textTransform: "none",
            color: "#555555", // inactive dark grey
            transition: "color 0.2s ease",
            minHeight: 32,
            paddingTop: "4px",
            paddingBottom: "4px",
          },

          "& .MuiTab-root:hover": {
            color: "#d2363a", // hover color
          },

          "& .Mui-selected": {
            color: "#d2363a !important", // active tab color
          },

          "& .MuiTabs-indicator": {
            backgroundColor: "#d2363a", // slider color
            height: "2px",
            transition: "all 0.3s ease",
          },
        }}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.value}
            label={tab.label}
            sx={{ fontFamily: "'Poppins', sans-serif" }}
          />
        ))}
      </Tabs>

      <Divider sx={{ mt: 0, borderColor: "#c35f61" }} />
    </Box>
  );
}
